<template>
  <div class="products">
      <div class="container">
          
        <div class="intro h-100">
            <div class="row h-100 justify-content-center align-items-center">
              <div class="col-md-6">
                    <h3>Productos </h3>
                    
                 <p>
                   Agregar o editar productos en la base de datos
                 </p>
              </div>
              <div class="col-md-6">
                  <img src="/img/svg/products.svg" alt="" class="img-fluid">
              </div>
            </div>
          </div>

          <hr>

          <div class="product-test">


            <h3 class="d-inline-block">Lista de Productos</h3>
            <button @click="addNew" class="btn btn-primary float-right">Agregar producto</button>

            <div class="table-responsive">
              
                <table class="table">
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Categoria</th>
                      <th>Editar</th>
                    </tr>
                  </thead>

                  <tbody>
                      <tr v-for="product in products">
                        <td>
                          {{product.name}}
                        </td>

                        <td>
                          {{product.line}}
                        </td>

                        <td>

                          <button class="btn btn-primary" @click="editProduct(product)">Editar</button>
                          <button class="btn btn-danger" @click="deleteProduct(product)">Borrar</button>
                        </td>

                      </tr>


                  </tbody>
                </table>
            </div>

          </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="product" tabindex="-1" role="dialog" aria-labelledby="editLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="editLabel">Editar Producto</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

                <div class="row">
                  <!-- main product -->
                  <div class="col-md-8">
                    <div class="form-group">
                      <input type="text" placeholder="Nombre del producto" v-model="product.name" class="form-control">
                    </div>
                    <div class="form-group">
                      <input type="text" placeholder="Tipo" v-model="product.tipo" class="form-control">
                    </div>

                    <div class="form-group">
                      <vue-editor v-model="product.description"></vue-editor>
                    </div>
                  </div>
                  <!-- product sidebar -->
                  <div class="col-md-4">
                    <h4 class="display-6">Detalles del producto</h4>
                    <hr>

                    <div class="form-group">
                      <select v-model="product.line" class="custom-select" id="inputGroupSelect01">
                        <option v-for="categoria in categorias" v-bind:value="categoria.name">
                          {{ categoria.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <multiselect v-model="product.colors"  :options="colors" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Selecciona color" label="name" track-by="name" :preselect-first="true"></multiselect>
                     
                    </div>

                    <div class="form-group">
                      <input type="text" @keyup.188="addExtra" placeholder="Product extras" v-model="extra" class="form-control">
                      
                      <div  class="d-flex">
                        <p v-for="extra in product.extras">
                            <span class="p-1">{{extra}}</span>
                        </p>

                      </div>
                    </div>

                    <div class="form-group">
                      <input type="text" @keyup.188="addTag" placeholder="Product tags" v-model="tag" class="form-control">
                      
                      <div  class="d-flex">
                        <p v-for="tag in product.tags">
                            <span class="p-1">{{tag}}</span>
                        </p>

                      </div>
                    </div>


                    <div class="form-group">
                      <label for="product_image">Imágenes</label>
                      <input type="file" @change="uploadImage" class="form-control">
                    </div>

                    <div class="form-group d-flex">
                      <div class="p-1" v-for="(image, index) in product.images">
                          <div class="img-wrapp">
                              <img :src="image" alt="" width="80px">
                              <span class="delete-img" @click="deleteImage(image,index)">X</span>
                          </div>
                      </div>
                    </div>

                  </div>
                </div>




            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
              <button @click="addProduct()" type="button" class="btn btn-primary" v-if="modal == 'new'">Guardar cambios</button>
              <button @click="updateProduct()" type="button" class="btn btn-primary" v-if="modal == 'edit'">Aplicar Cambios</button>
            </div>
          </div>
        </div>
      </div>


    
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { fb, db} from '../firebase';
import Multiselect from 'vue-multiselect'

export default {
  name: "Products",
  components: {
    VueEditor,
    Multiselect
  },
  props: {
    msg: String
  },

  data(){
    return {
        products: [],
        product: {
          name:null,
          description:null,
          line:null,
          tipo: null,
          colors:[],
          tags:[],
          images:[],
          extras:[]
        },
        categorias: [],
        colors:[],
        activeItem:null,
        modal: null,
        tag: null,
        extra: null,
        color: []
    }
  },

  firestore(){
      return {
        products: db.collection('products'),
         categorias: db.collection('categorias'),
         colors: db.collection('colors')
      }
  },
  methods:{

    inicializarSelect(){
      $('.my-select').selectpicker();
    },

    deleteImage(img,index){

      let image = fb.storage().refFromURL(img);

      this.product.images.splice(index,1);

      image.delete().then(function() {
        console.log('imagen eliminada');
      }).catch(function(error) {
        // Uh-oh, an error occurred!
        console.log('ocurrió un error');
      });

    },

    addTag(){
       this.product.tags.push(this.tag);
       this.tag = "";
    },
    addExtra(){
       this.product.extras.push(this.extra);
       this.extra = "";
    },
    addColor(){
       this.product.colors.push(this.color);
       this.color = "";
    },
    uploadImage(e){

      if(e.target.files[0]){
        
          let file = e.target.files[0];
    
          var storageRef = fb.storage().ref('products/'+ Math.random() + '_'  + file.name);
    
          let uploadTask  = storageRef.put(file);
    
          uploadTask.on('state_changed', (snapshot) => {
            
          }, (error) => {
            // Handle unsuccessful uploads
          }, () => {
            // Handle successful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              this.product.images.push(downloadURL);
            });

          });

      }




    },

    reset(){
      this.product = {
          name:null,
          description:null,
          line:null,
          tipo: null,
          colors:[],
          tags:[],
          images:[],
          extras:[]
      }
    },

    addNew(){
        this.modal = 'new';
        this.reset();
        $('#product').modal('show');
    },
    updateProduct(){
        this.$firestore.products.doc(this.product.id).update(this.product);
          Toast.fire({
            type: 'success',
            title: 'Updated  successfully'
          })

           $('#product').modal('hide');
    },

    editProduct(product){
      this.modal = 'edit';
      this.product = product;
      $('#product').modal('show');
    },


    deleteProduct(doc){

      Swal.fire({
        title: 'Está seguro?',
        text: "Los cambios no podrán ser revertidos!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, elimínalo!'
      }).then((result) => {
        if (result.value) {

          this.$firestore.products.doc(doc.id).delete()

          Toast.fire({
            type: 'success',
            title: 'Eliminado  satisfactoriamente'
          })

        
        }
      })
        
    },
    readData(){

      
     
    },
    addProduct(){
      
      this.$firestore.products.add(this.product);
      
          Toast.fire({
            type: 'success',
            title: 'Producto creado satisfactoriamente'
          })

      $('#product').modal('hide');
    }

  
  },
  created(){
  
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.img-wrapp{
  position: relative;
}
.img-wrapp span.delete-img{
    position: absolute;
    top: -14px;
    left: -2px;
}
.img-wrapp span.delete-img:hover{
  cursor: pointer;
}

</style>
